var SUPER_ADMIN = '@base-role/super-admin';
var ORGANIZATION_ADMIN = '@base-role/org-admin';
var SCHOOL_ADMIN = '@base-role/school-admin';
var HOD = '@base-role/head-of-department';
var PRINCIPAL = '@base-role/principal';
var PARENT = '@base-role/parent';
var TEACHER = '@base-role/teacher';
var STUDENT = '@base-role/student';
export default {
  SUPER_ADMIN: SUPER_ADMIN,
  ORGANIZATION_ADMIN: ORGANIZATION_ADMIN,
  SCHOOL_ADMIN: SCHOOL_ADMIN,
  HOD: HOD,
  PRINCIPAL: PRINCIPAL,
  PARENT: PARENT,
  TEACHER: TEACHER,
  STUDENT: STUDENT
};